var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-row',{attrs:{"vs-w":"12"}},[_c('vs-col',{staticClass:"p-2",attrs:{"vs-w":"5","vs-sm":"12"}},[_c('basic-settings')],1),_c('vs-col',{staticClass:"p-2",attrs:{"vs-w":"7","vs-sm":"12"}},[_c('multipliers-table')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }